import { Spinner } from "react-bootstrap";
import { useState } from "react";
import Cookies from "js-cookie";
import regenerateToken from "../regenerateToken";
import { positions, useAlert } from "react-alert";
import { FaFilePdf, FaCloudUploadAlt, FaDownload, FaSave } from "react-icons/fa";
import axios from 'axios';
import { buildRequestConfig } from '../../utils/apiHelper';
import { isAdmin as checkAdmin } from '../../utils/authUtils';

const BackPageConfig = ({
  backpageMap,
  retrieveExistingStateConfiguration,
}) => {
  const alert = useAlert();
  const [backpageBase64, setBackpageBase64] = useState("");
  const [backpageIdentifier, setBackpageIdentifier] = useState("default");
  // const [searchBackpage, setSearchBackpage] = useState(""); // Unused in active UI
  // const [backPageUploadError, setBackPageUploadError] = useState(""); // Unused
  const [myFile, setMyFile] = useState("");
  const [loader, setLoader] = useState(false);
  // const [getLoader, setGetloader] = useState(false); // Unused
  // const [backpageUrl, setBackpageUrl] = useState(""); // Unused

  const convertBase64 = (file) => {
    if (file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
        fileReader.onerror = (error) => {
          reject(error);
        };
      });
    } else {
      return "";
    }
  };

  const handleBackpageUpload = (event) => {
    let files = event.target.files;
    let fileSize = files[0]?.size;
    let fileSizeInMb = fileSize / (1024 * 1024);

    // setBackPageUploadError("");
    if (files?.length > 1) {
      alert.error(
        <span className="alertError">Please upload only 1 file.</span>,
        {
          position: positions.TOP_CENTER,
        }
      );

      return;
    }
    if (files[0]?.type != "application/pdf") {
      alert.error(
        <span className="alertError">Please upload a pdf file.</span>,
        {
          position: positions.TOP_CENTER,
        }
      );

      return;
    }
    if (fileSize && fileSizeInMb > 1.5) {
      alert.error(
        <span className="alertError">
          File size should be less than 1.5 MB
        </span>,
        {
          position: positions.TOP_CENTER,
        }
      );
      return;
    }

    setMyFile(files[0]);
  };

  const saveBase64 = async (e) => {
    e.preventDefault();
    let fileBase64 = await convertBase64(myFile);
    if (fileBase64) setBackpageBase64(fileBase64);
  };

  const uploadBackpage = async () => {
    let payload = {
      backPageIdentifier: backpageIdentifier,
      backPageBase64: backpageBase64,
    };
    const apiUrl =
      "https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/assets/backpage";
    // ── ADMIN PATH: use admin token (axios) + inject clientId if a client is selected
    if (checkAdmin()) {
      return await axios(buildRequestConfig({ method: "POST", url: apiUrl, data: payload }));
    }
    // ── CLIENT PATH (unchanged — uses native fetch) ────────────────────
    const idToken = Cookies.get("idToken");
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: idToken,
      },
      body: JSON.stringify(payload),
    };

    const response = await fetch(apiUrl, options);

    return response;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoader(true);

    try {
      const response = await uploadBackpage();
      if (response.status === 401) {
        await regenerateToken();
        const response = await uploadBackpage();
        const data = await response.json();

        if (data.isSuccess) {
          alert.success(<span>Backpage uploaded succesfully!</span>, {
            position: positions.TOP_CENTER,
          });
        }
      } else {
        const data = await response.json();
        if (data.isSuccess) {
          alert.success(<span>Backpage uploaded succesfully!</span>, {
            position: positions.TOP_CENTER,
          });
        } else {
        }
      }
    } catch (e) {
      alert.error(
        <span className="alertError">
          Something went wrong. Please try again.
        </span>,
        {
          position: positions.TOP_CENTER,
        }
      );
    } finally {
      setBackpageIdentifier("default");
      setLoader(false);
      retrieveExistingStateConfiguration();
    }
  };

  return (
    <div className="am-section">
      <div className="am-section-header">
        <h4><FaFilePdf style={{ color: '#ef4444' }} /> Back Page Configuration</h4>
      </div>

      <div className="am-section-body">
        <div className="am-grid">
          {/* Left: Upload Form */}
          <div>
            <form onSubmit={handleSubmit}>
              <div className="am-form-group">
                <label className="am-label">Backpage Identifier</label>
                <input
                  className="am-input"
                  type="text"
                  value={backpageIdentifier}
                  required
                  onChange={(e) => setBackpageIdentifier(e.target.value)}
                />
              </div>

              <div className="am-form-group">
                <label className="am-label">Upload PDF</label>
                <div className="am-file-upload" onClick={() => document.getElementById('bp-upload').click()}>
                  <div style={{ pointerEvents: 'none' }}>
                    <FaCloudUploadAlt size={32} color="#94a3b8" />
                    <p style={{ margin: '0.5rem 0 0', color: '#64748b' }}>
                      {myFile ? myFile.name : "Click to Select PDF File"}
                    </p>
                    <p className="am-helper-text">Max size 1.5MB</p>
                  </div>
                </div>
                <input
                  id="bp-upload"
                  type="file"
                  accept="application/pdf"
                  onChange={(event) => handleBackpageUpload(event)}
                  style={{ display: 'none' }}
                />
              </div>

              <div style={{ display: 'flex', gap: '1rem' }}>
                <button
                  className="am-btn am-btn-primary"
                  onClick={saveBase64}
                  disabled={!myFile}
                  type="button"
                >
                  <FaSave /> Save
                </button>
                <button
                  className="am-btn am-btn-primary"
                  type="submit"
                  disabled={!backpageBase64}
                >
                  {loader ? <Spinner animation="border" size="sm" /> : <><FaCloudUploadAlt /> Upload</>}
                </button>
              </div>
            </form>
          </div>

          {/* Right: Existing List */}
          <div>
            <h5 className="am-label" style={{ fontSize: '1rem', marginBottom: '1rem' }}>Existing Back Pages Library</h5>
            <div className="am-list-container">
              <div className="am-list-header">
                <div>SN</div>
                <div>Identifier Label</div>
                <div style={{ textAlign: 'center' }}>Action</div>
              </div>
              <div className="am-list-body">
                {typeof backpageMap === "object" && !Object.keys(backpageMap).length ? (
                  <div className="p-4 text-center text-muted">No back pages found.</div>
                ) : typeof backpageMap === "object" && Object.keys(backpageMap).length ? (
                  Object.keys(backpageMap).map((each, idx) => (
                    <div className="am-list-item" key={idx + 1}>
                      <div>{idx + 1}</div>
                      <div>{each}</div>
                      <div style={{ textAlign: 'center' }}>
                        <a
                          href={backpageMap[each]}
                          download
                          className="am-link"
                          title="Download PDF"
                        >
                          <FaDownload />
                        </a>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="p-4 text-center text-muted">No data found.</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackPageConfig;
